import clsx from "clsx";
import type { DayAZM } from "../lib/types";
import { fmtShortDay } from "../lib/format";

interface WeekDotsProps {
  /** Daily rows covering at least the most recent 7 days. */
  rows: DayAZM[];
}

/**
 * Compact strip of the current week's dots, oldest -> newest.
 */
export default function WeekDots({ rows }: WeekDotsProps) {
  const tail = rows.slice(-7);
  return (
    <div className="mt-2 flex items-center gap-1.5">
      {tail.map((d, i) => {
        const isLast = i === tail.length - 1;
        const active = d.minutes > 0;
        return (
          <div
            key={d.date}
            className="flex flex-col items-center gap-1"
            title={`${fmtShortDay(d.date)} · ${d.minutes} AZM`}
          >
            <span
              className={clsx(
                "h-2.5 w-2.5 rounded-full",
                active ? "bg-accent" : "bg-zinc-200 dark:bg-zinc-700",
                isLast && "ring-2 ring-offset-2 ring-accent/60 ring-offset-white dark:ring-offset-zinc-900",
              )}
            />
            <span className="text-[10px] text-zinc-400">
              {fmtShortDay(d.date).slice(0, 1)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
